export const formatCreditsSyncTime = (
  value,
  locales,
  timeZone,
) => {
  if (!value) return "Not synced yet";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Not synced yet";

  const sharedOptions = timeZone ? { timeZone } : {};
  const dateText = new Intl.DateTimeFormat(locales, {
    ...sharedOptions,
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(date);
  const timeText = new Intl.DateTimeFormat(locales, {
    ...sharedOptions,
    hour: "numeric",
    minute: "2-digit",
  }).format(date);

  return `Last synced ${dateText} at ${timeText}`;
};
